/**
 * Component per mostrar un LOT
 * Component: LotDialog.tsx
 * Llenguatge: TypeScript
 * Autors: Xavier Naval
 * Versió: 1.0
 * Data: 06/04/2020
 * (c) Ajuntament de Manresa - set 2017 - Departament de Sistemes d'Informació
 */

import * as React from 'react';
import { observer } from 'mobx-react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TableContainer } from '@material-ui/core';
import DataGrid from 'ajt-data-grid';
import DataGridField from 'ajt-data-grid/lib/src/DataGridField';
import { ILot } from '../interfaces/ILot';
import { ICat } from '../interfaces/IMapConfig';
import { ICatLot } from '../interfaces/ICatLot';
import Util from '../config/util';

interface IPropsLotDialog {
    lot: ILot;
    categories: Array<ICat>;
    catsLots: Array<ICatLot>;
    onClose: (cat: number) => void;
};

interface ILinia {
    titol: string;
    contingut: string;
}

@observer
export default class LotDialog extends React.Component<IPropsLotDialog, {}> {

    // Tanca el diàleg
    private handleClose = (cat: number, event: {}) => {
        this.props.onClose(cat);
    }

    // Render !
    render(): JSX.Element {
        let linies: Array<ILinia> = [];
        linies.push({titol: 'ADREÇA', contingut: this.props.lot.carDesc});
        linies.push({titol: 'FANALS', contingut: this.props.lot.fanals.toString()});
        linies.push({titol: 'CATEGORIA', contingut: this.props.lot.cat.toString()});

        // Rederitzem
        return (<Dialog 
                open={!!this.props.lot}
                onClose={this.handleClose}
            >
                <DialogTitle id="form-dialog-title">{'Lot ' + this.props.lot.lot.toString()}</DialogTitle>
                <DialogContent>
                    <TableContainer style={{maxHeight: '250px'}}>
                        <DataGrid
                            fixedHeader={true}
                            showRowHover={true}
                            dataSource={linies}
                            size="small"
                        >
                            <DataGridField field="titol" title=" " width={150} style={{textAlign: 'left'}} styleHeader={{textAlign: 'left'}}/>
                            <DataGridField field="contingut" title=" " width={300} style={{textAlign: 'left'}} styleHeader={{textAlign: 'left'}}/>
                        </DataGrid>
                    </TableContainer>
                    <p />
                    <table>
                        <tbody>
                            <tr>
                                {this.props.catsLots.map((cLot: ICatLot, i: number) => {
                                    return (
                                        <td key={i}>
                                            {cLot.cat === 0 && <>&nbsp;&nbsp;</>}
                                            <Button
                                                style={{
                                                    borderRadius: 19,
                                                    backgroundColor: this.props.categories[i].max && cLot.nFanals >= this.props.categories[i].max ? '#c0c0c0' : this.props.categories[i].color,
                                                    padding: '6px',
                                                    fontSize: '14px',
                                                    borderWidth: cLot.cat === this.props.lot.cat ? '3px' : '0px',
                                                    borderColor: '#000000'
                                                }}
                                                variant={cLot.cat !== this.props.lot.cat ? 'contained' : 'outlined'}
                                                size="small"
                                                disabled={this.props.categories[i].max && (cLot.nFanals >= this.props.categories[i].max) ? true : false}
                                                disableElevation={cLot.cat !== this.props.lot.cat}
                                                onClick={this.handleClose.bind(this, cLot.cat)}
                                            >
                                                <span style={{color: Util.isDark(this.props.categories[i].color) ? '#ffffff' : '#000000'}}>{cLot.cat}</span>
                                            </Button>
                                            {cLot.cat !== 0 && <>&nbsp;</>}
                                        </td>
                                    );
                                })}
                            </tr>
                        </tbody>
                    </table>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose.bind(this, -1)} color="secondary">Tancar</Button>
                </DialogActions>
            </Dialog>);
    }
}